import { AuthContext } from 'shared/context/auth-context';
import React, { useContext } from 'react';
import { Card } from 'antd';
import { headerStyle } from 'shared/styles/baseStyle';
import TabPanel from 'components/TabPanel/TabPanel';
import InfoContract from './TabPanels/InfoContract';
import Alarms from './TabPanels/Alarms';
import Messages from './TabPanels/Messages';
import Trips from './TabPanels/Trips/Trips';
import SuspendedTrips from './TabPanels/Trips/SuspendedTrips';
import Packages from './TabPanels/Packages';
import HistoryOBD from './TabPanels/HistoryOBD';
import Problems from './TabPanels/Problems';
import Permissions from './TabPanels/Permissions';

export default function DetailsOfInsuranceContract() {
  const { roleUser } = useContext(AuthContext);
  const tabInfo = [
    {
      key: 1,
      tab: 'Στοιχεία',
      role: ['AnyTimeAdmin', 'AnyTime', 'GT'],
      component: <InfoContract />
    },
    {
      key: 2,
      tab: 'SMS/EMAIL',
      component: <Messages />,
      role: ['AnyTimeAdmin', 'AnyTime', 'GT']
    },
    {
      key: 3,
      tab: 'Alarms',
      component: <Alarms />,
      role: ['AnyTimeAdmin', 'AnyTime', 'GT']
    },
    {
      key: 4,
      tab: 'Διαδρομές',
      component: <Trips />,
      role: ['AnyTimeAdmin', 'AnyTime', 'GT']
    },
    {
      key: 5,
      tab: 'Αποκλεισμένες',
      component: <SuspendedTrips />,
      role: ['GT']
    },
    {
      key: 6,
      tab: 'Αλλαγές Πακέτων',
      component: <Packages />,
      role: ['AnyTimeAdmin', 'GT']
    },
    {
      key: 7,
      tab: 'Άδειες',
      component: <Permissions />,
      role: ['AnyTimeAdmin', 'GT']
    },
    {
      key: 8,
      tab: 'Ιστορικό OBD',
      component: <HistoryOBD />,
      role: ['AnyTimeAdmin', 'GT']
    },
    {
      key: 9,
      tab: 'Προβλήματα',
      component: <Problems />,
      role: ['GT']
    }
  ];

  const getAllowedTabs = tabInfo.filter(
    tab => tab.role.indexOf(roleUser) !== -1
  );
  return (
    <Card
      type="inner"
      headStyle={headerStyle}
      title="Πληροφορίες Ασφαλιστηρίου.Περιηγηθείτε στις καρτέλες για επιπλέον πληροφορίες"
    >
      <TabPanel tabInfo={getAllowedTabs} />
    </Card>
  );
}
